import Cookies from 'js-cookie';
import { Component } from 'react';
import { connect } from 'react-redux';

import { getClub, clubJoinGTM, clubClick } from 'redux/clubs/actions';
import { getClubBySlug } from 'redux/clubs/reducers';
import { getCustomer } from 'redux/customer/actions';

import Edit from './Edit';
import JoinWidget from './JoinWidget';

class JoinOrEdit extends Component {
  componentDidMount() {
    const { props } = this;
    const { slug } = props;
    props.getClub(slug);
    props.getCustomer();
  }

  render() {
    const { props } = this;
    const { club, customer, deliveryMethod = 'Ship' } = this.props;
    if (!club) {
      return null;
    }
    if (!Cookies.get('customerToken')) {
      return (
        <JoinWidget
          club={club}
          deliveryMethod={deliveryMethod}
          onClickGTM={props.clubClick}
        />
      );
    }
    if (!club || !customer || !customer.data) {
      return null;
    }
    const { isActive, clubMembershipId } = isClubMember(club, customer.data);
    if (isActive) {
      return <Edit clubMembershipId={clubMembershipId} />;
    }
    props.clubJoinGTM({ clubs: [{ club }] });
    return (
      <JoinWidget
        club={club}
        deliveryMethod={deliveryMethod}
        onClickGTM={props.clubClick}
      />
    );
  }
}

const isClubMember = (club, customer) => {
  const results = {
    clubMembershipId: null,
    isActive: false
  };
  if (!customer.clubs) {
    return results;
  }
  const activeClubMembership = customer.clubs.find((c) => {
    if (
      c.clubId === club.id &&
      new Date(c.signupDate) < new Date() &&
      (!c.cancelDate || new Date(c.cancelDate) > new Date())
    ) {
      return true;
    }
    return false;
  });
  if (activeClubMembership) {
    results.clubMembershipId = activeClubMembership.clubMembershipId;
    results.isActive = true;
  }
  return results;
};

const mapStateToProps = (state, ownProps) => ({
  club: getClubBySlug(state.club, ownProps.slug),
  customer: state.customer
});

export default connect(mapStateToProps, {
  getClub,
  getCustomer,
  clubJoinGTM,
  clubClick
})(JoinOrEdit);
